import vue from "vue";
import router from "vue-router";
import store from "./stores/index.js";

vue.use(router);

/*
	This will cehck to see if the user is authenticated or not.
*/
function notrequireAuth(to, from, next) {
	for (var i in to.params) {
		let payload = { nombre: i, valor: to.params[i] };
		store.dispatch("navegacion/set_parametro", payload);
	}
	if (from !== undefined && from.path !== '/') {
		localStorage.setItem("pathfrom", from.path);
		localStorage.setItem("titlefrom", from.meta.title);
	}
	next();
}

function requireAuth(to, from, next) {
	/*
		Determines where we should send the user.
		*/
	//store.dispatch("mensaje/set_reset");
	function evaluate() {
		let opciones = store.getters["gopciones"];
		let opcion = opciones.filter(item => item.codigo === to.meta.codigo);
		if (opcion.length > 0) {
			for (var i in to.params) {
				let payload = { nombre: i, valor: to.params[i] };
				store.dispatch("navegacion/set_parametro", payload);
			}

			if (from !== undefined) {
				localStorage.setItem("pathfrom", from.path);
				if (from.meta.title !== undefined) {
					localStorage.setItem("titlefrom", from.meta.title);
				}
			}
			next();
		} else {
			next(from);
		}
	}

	function proceed() {
		/*
			If the user has been loaded determine where we should
			send the user.
		*/
		if (localStorage.usuario !== undefined) {
			/*
				If the user is not empty, that means there's a user
				authenticated we allow them to continue. Otherwise, we
				send the user back to the home page.
						*/
			let opciones = store.getters["gopciones"];
			if (opciones.length === 0) {
				store.dispatch("get_porusuario");
				store.watch(
					() => store.getters["gopciones"],
					() => {
						evaluate();
					}
				);
			} else {
				evaluate();
			}
		}
	}

	/*
		Confirms the user has been loaded
		*/
	if (localStorage.usuario === undefined) {
		next(from);
	} else {
		proceed();
	}
}

/*
	Makes a new VueRouter that we will use to run all of the routes
	for the app.
*/

const DEFAULT_TITLE = "SIIPO v2.0";
let defaultRoute = "home";
let routes = new router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			redirect: { name: defaultRoute }
			, beforeEnter: notrequireAuth
		},
		{
			path: "/home",
			name: "home",
			meta: {
				title: "Sistema Integrado de Información para el Posconflicto"
			},
			component: () => import("@/pages/home.vue")
			, beforeEnter: notrequireAuth

		},
		{
			path: "/inicio",
			name: "inicio",
			meta: {
				title: "Sistema Integrado de Información para el Posconflicto"
			},
			component: () => import("@/pages/inicio.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "reporteindicadores",
			path: "/reportes/indicadores:idindicador?",
			meta: { title: "Avance indicadores" },
			component: () => import("@/pages/reportes/indicadores.vue")
		},
		{
			path: "/marco",
			name: "marco",
			meta: {
				title: "Marco",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Marco de Referencia' }]
			},
			component: () => import("@/pages/marco.vue")
			, beforeEnter: notrequireAuth

		},
		{
			path: "/reporte/:ruta?",
			name: "reporte",
			meta: {
				title: "Reporte",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: '{{Reporte}}' }]
			},
			component: () => import("@/pages/contenido/reporte.vue")
			, beforeEnter: notrequireAuth

		},
		{
			path: "/pregunta",
			name: "pregunta",
			meta: {
				title: "Preguntas frecuentes",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Preguntas frecuentes' }]
			},
			component: () => import("@/pages/preguntas.vue")
			, beforeEnter: notrequireAuth

		}
		,
		{
			name: "pilar",
			path: "/pilar/:idpunto?",
			meta: {
				title: "Avance por punto",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Pilar' }]
			},
			component: () => import("@/pages/avance/pilar.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "estrategia",
			path: "/estrategia/:idpunto?/:idpilar?",
			meta: {
				title: "Avance por punto",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Pilar', href: '/pilar/:idpunto' }
					, { text: 'Avance por Estrategia' }]
			},
			component: () => import("@/pages/avance/estrategia.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "detalleindicadorsalto",
			path: "/detalleindicadorsalto/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Pilar', href: '/pilar/:idpunto' }
					, { text: 'Avance por Estrategia', href: '/estrategia/:idpunto?/:idpilar?' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detallesalto.vue")
			, beforeEnter: notrequireAuth
		},
		{
			name: "detalleindicador",
			path: "/detalleindicador/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Pilar', href: '/pilar/:idpunto' }
					, { text: 'Avance por Estrategia', href: '/estrategia/:idpunto?/:idpilar?' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detalle.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "detalleClasificador",
			path: "/detalleclasificaindicador/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Clasificación', href: '/avance/clasificacion/:idclasificacion?' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detalle.vue")
			, beforeEnter: notrequireAuth

		},
		{
			props: true,
			name: "avance-clasificacionpdte",
			path: "/avance/clasificacionpdte/:idpunto?/:idclasificacion?",
			meta: {
				title: "Avance por clasificacion", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Programas de Desarrollo con Enfoque Territorial (PDET).', href: '/iniciopdet' }
					, { text: 'Avance por Clasificación' }]
			},
			component: () => import("@/pages/avance/clasificacionpdte.vue"),
			beforeEnter: notrequireAuth
		},

		{
			name: "detalle Entidad Indicador",
			path: "/detalleentidadindicador/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Detalle de indicador por entidad', href: '/detalleentidad' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detalle.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "sectorcomparativo",
			path: "/sectorcomparativo",
			meta: {
				codigo: "O005-1", title: "Comparativo por sector",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Comparativo por sector' }]
			},
			component: () => import("@/pages/avance/sectorcomparativo.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "sectordetalle",
			path: "/sectordetalle",
			meta: {
				codigo: "O005-2", title: "Tablero sectorial",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Tablero sectorial' }]
			},
			component: () => import("@/pages/avance/sectordetallepuntos.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "sectorclasificacion",
			path: "/sectorclasificacion",
			meta: {
				codigo: "O005-4", title: "Tablero sectorial por clasificador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Tablero sectorial por clasificador' }]
			},
			component: () => import("@/pages/avance/sectordetalleclasificacion.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "entidadcomparativo",
			path: "/entidadcomparativo",
			meta: {
				codigo: "O005-3", title: "Comparativo por entidad",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Comparativo por entidad' }]
			},
			component: () => import("@/pages/avance/entidadcomparativo.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/tareas",
			name: "tareas",
			meta: {
				codigo: "O007", title: "Mis tareas", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas' }]
			},
			component: () => import("@/pages/tarea/tareas.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/admindicador",
			name: "indicadores",
			meta: {
				codigo: "O004-1", title: "Seguimiento a indicadores", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Seguimiento a indicadores' }]
			},
			component: () => import("@/pages/indicador/admindicador.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/olvidoclave/:enlace?",
			name: "Olvido clave",
			meta: {
				codigo: "", title: "Olvido de contraseña", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Olvido de contraseña' }]
			},
			component: () => import("@/pages/administrador/olvido.vue"),
			beforeEnter: notrequireAuth
		},
		{
			path: "/ingreso",
			name: "ingreso",
			meta: { title: "Ingreso al sistema" },
			component: () => import("@/pages/ingreso.vue")
		},
		{
			props: true,
			name: "avance-clasificacion",
			path: "/avance/clasificacion/:idclasificacion?",
			meta: {
				title: "Avance por clasificacion", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Avance por Clasificación' }]
			},
			component: () => import("@/pages/avance/clasificacion.vue"),
			beforeEnter: notrequireAuth
		},
		{
			name: "FichaTecnica",
			path: "/indicador/fichatecnicaseguimiento/:idindicador?",
			meta: {
				codigo: "O004-1", title: "Ficha técnica", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Seguimiento a indicadores', href: '/admindicador' }
					, { text: 'Ficha de indicador' }]
			},
			component: () => import("@/pages/indicador/fichatecnica.vue")
			, beforeEnter: requireAuth

		},
		{
			name: "FichaTecnica",
			path: "/indicador/fichatecnica/:idindicador?",
			meta: {
				codigo: "O004-1", title: "Ficha técnica", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Ficha de indicador' }]
			},
			component: () => import("@/pages/indicador/fichatecnica.vue")
			, beforeEnter: requireAuth

		},
		{
			name: "ReporteAvance",
			path: "/indicador/reportedeavances/:idindicador?",
			meta: {
				codigo: "O004-1", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Reporte de avance' }]
			},
			component: () => import("@/pages/indicador/reportedeavances.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "ReporteHito",
			path: "/indicador/reportedehitos/:idhito?",
			meta: {
				codigo: "O004-1", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Reporte de hito' }]
			},
			component: () => import("@/pages/indicador/reportehito.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "AdministraRol",
			path: "/administrador/rol",
			meta: { codigo: "O007-1" },
			component: () => import("@/pages/administrador/rol.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "AdministraUsuario",
			path: "/administrador/usuario",
			meta: { codigo: "O007-2", title: "Administración de usuarios" },
			component: () => import("@/pages/administrador/usuario.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "Auditoria",
			path: "/administrador/auditoria",
			meta: {
				codigo: "O007-3", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Auditoría' }]
			},
			component: () => import("@/pages/administrador/auditoria.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "AdministraTemporizaciones",
			path: "/administrador/temporizacion",
			meta: {
				codigo: "O007-2", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Temporización' }]
			},
			component: () => import("@/pages/administrador/temporizacion.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/detalleentidad",
			name: "detalle",
			meta: {
				codigo: "O006", title: "Seguimiento a indicadores", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Detalle de indicador por entidad' }]
			},
			component: () => import("@/pages/avance/detalleentidad.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "consultaindicadores",
			path: "/buscarindicador",
			meta: {
				codigo: "O009-1", title: "Consulta de indicadores",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Consulta de los indicadores' }]
			},
			component: () => import("@/pages/indicador/buscarindicador.vue"),
		},
		{
			name: "detallepublicoindicador",
			path: "/detallepublicoindicador/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Consulta de los indicadores', href: '/buscarindicador' }
					, { text: 'detalle de indicadores' }],
			},
			component: () => import("@/pages/indicador/detalle.vue")
			, beforeEnter: notrequireAuth

		},
		/*
		{
			name: "detallepublicoindicadordesagregado",
			path: "/detallepublicoindicadordesagregado/:idindicador/:idtipovalor",
			meta: {
				title: "Desagregación de indicador",
				breadcrumb: [{ text: 'Desagregación de indicadores' }],
			},
			component: () => import("@/pages/indicador/desagregacion.vue")
			, beforeEnter: notrequireAuth,
			props: true

		},*/
		{
			path: "*",
			redirect: { name: defaultRoute }
		}
		,
		{
			name: "AdministraFuente",
			path: "/administrador/fuente",
			meta: {
				codigo: "O007-4",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Administración de fuentes de financiamiento' }
				]
			},
			component: () => import("@/pages/administrador/fuente.vue"),
			beforeEnter: requireAuth
		}
		,
		{
			name: "AdministraNacional",
			path: "/administrador/nacional",
			meta: {
				codigo: "O007-5",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Administración de planes nacionales' }
				]
			},
			component: () => import("@/pages/administrador/nacional.vue"),
			beforeEnter: requireAuth
		}
		,
		{
			name: "FormulaNacional",
			path: "/formulacionnacional/:idnacionalformulacion",
			meta: {
				title: "Formulación de planes nacionales", codigo: "O007", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Formulación del plan de acción' }]
			},
			component: () => import("@/pages/nacional/formulacion.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "Cuestionarios",
			path: "/administrador/cuestionario",
			meta: {
				codigo: "O007-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Administrar cuestionarios' }
				]
			},
			component: () => import("@/pages/administrador/cuestionario.vue"),
			beforeEnter: requireAuth
		}
		,
		{
			name: "AvanceFormulaNacional",
			path: "/seguimientonacional/:idavancenacional",
			meta: {
				codigo: "O007", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Seguimiento de plan nacional' }]
			},
			component: () => import("@/pages/nacional/seguimiento.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "Planes Nacionales Sectoriales ciudadano",
			path: "/plannacionalvista",
			meta: {
				codigo: "O002-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Planes Nacionales de la Reforma Rural Integral – PNRRI' }
				]
			},
			component: () => import("@/pages/nacional/vistaciudadano.vue")
		},
		{
			name: "Detalle plan nacional",
			path: "/vistaciuddanodetallato/:idnacional",
			meta: {
				codigo: "O002-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Planes Nacionales Sectoriales', href: '/plannacionalvista' }
					, { text: 'Detallado' }]
			},
			component: () => import("@/pages/nacional/vistaciuddanodetallato.vue")
		},
		{
			name: "Detallado plan nacional",
			path: "/vistaciuddanodetallato/:idnacional/:idvigencia",
			meta: {
				codigo: "O005-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Plan nacional', href: '/tableroPNS' }
					, { text: 'Detallado' }]
			},
			component: () => import("@/pages/nacional/vistaciuddanodetallato.vue")
		},
		{
			name: "Planes Nacionales Sectoriales",
			path: "/tableroPNS",
			meta: {
				codigo: "O005-5", breadcrumb: [{ text: 'Home', href: '/inicio' }
					, { text: 'Planes Nacionales Sectoriales', href: '/tableroPNS' }
					, { text: 'Detallado' }]
			},
			component: () => import("@/pages/nacional/tableroPNS.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "Plan nacional de desarrollo",
			path: "/plannacionaldesarrollo",
			meta: {
				codigo: "O002-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Plan Nacional de Desarrollo' }
				]
			},
			component: () => import("@/pages/PND/comparativogeneral.vue")
		},
		{
			name: "Detalle plan nacional de desarrollo",
			path: "/detalleplannacionaldesarrollo/:idplannacionaldesarrollo?/:idpunto?/:idnivelpnd?/:periodo?",
			meta: {
				codigo: "O002-5", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Plan Nacional de Desarrollo', href: '/plannacionaldesarrollo' }
					, { text: 'Detalle del Plan nacional de Desarrollo' }
				]
			},
			component: () => import("@/pages/PND/comparativodetalle.vue")
		},
		{
			name: "detalleindicadorpublico",
			path: "/detalleindicadorpublico/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Plan nacional de desarrollo', href: '/plannacionaldesarrollo' }
					, { text: 'Detalle del Plan nacional de Desarrollo', href: '/detalleplannacionaldesarrollo' }
					, { text: 'detalle de indicadores' }],
			},
			component: () => import("@/pages/indicador/detalle.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "Financiación del Acuerdo",
			path: "/recursos",
			meta: {
				codigo: "O002-7", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Financiación del Acuerdo' }
				]
			},
			component: () => import("@/pages/SPI/recursos.vue")
		},
		{
			name: "recursos inversion",
			path: "/recursosinversion",
			meta: {
				codigo: "O002-7", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Financiación del Acuerdo', href: '/recursos' }
					, { text: 'Presupuesto General de la Nación > Apropiación Presupuestal > Inversión' }
				]
			},
			component: () => import("@/pages/SPI/recursosinversion.vue")
		},
		{
			name: "recursos funcionamiento",
			path: "/recursosfuncionamiento",
			meta: {
				codigo: "O002-7", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Financiación del Acuerdo', href: '/recursos' }
					, { text: 'Presupuesto General de la Nación > Apropiación Presupuestal > Funcionamiento' }
				]
			},
			component: () => import("@/pages/SPI/recursosfuncionamiento.vue")
		},
		{
			name: "Apropiación presupuestal",
			path: "/recursosapropiacionpresup/:idpunto/:vigencia",
			meta: {
				codigo: "O002-7", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Financiación del Acuerdo', href: '/recursos' }
					, { text: 'Plan Plurianual de Inversiones Paz >Apropiación Presupuestal' }
				]
			},
			component: () => import("@/pages/SPI/recursosapropiacionpresup.vue")
		},
		{
			name: "EdicionMetas",
			path: "/indicador/ediciondemetas/:idindicador?",
			meta: {
				codigo: "O004-1", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Mis tareas', href: '/tareas' }
					, { text: 'Edición de metas' }]
			},
			component: () => import("@/pages/indicador/ediciondemetas.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "SectorEntidad",
			path: "/administrador/sectorentidad",
			meta: { codigo: "O007-8" },
			component: () => import("@/pages/administrador/sectorentidad.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "EdicionAvances",
			path: "/administrador/avances/:idindicador?",
			meta: {
				codigo: "O004-1", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Seguimiento a indicadores', href: '/admindicador' }
					, { text: 'Edición de avances' }]
			},
			component: () => import("@/pages/administrador/avances.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "Detalle Hito",
			path: "/detallehito/:idhito",
			meta: {
				title: "Detalle del hito", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Detalle de indicador por entidad', href: '/detalleentidad' }
					, { text: 'Detalle de indicador', href: '/detalleentidadindicador/:idindicador' }
					, { text: 'Detalle Hito' }]
			},
			component: () => import("@/pages/indicador/detallehito.vue"),
			beforeEnter: notrequireAuth
		},
		{
			name: "Detalle Auditoria",
			path: "/detalleauditoria/:idtabla/:idregistro",
			meta: {
				codigo: 'O004-1-7', title: "Detalle auditoria", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Ficha de indicador', href: '/indicador/fichatecnica/:idindicador?' }
					, { text: 'Detalle auditoría' }]
			},
			component: () => import("@/pages/indicador/detalleauditoria.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "AdministraciondeFlujos",
			path: "/administrador/flujos",
			meta: {
				codigo: "O008-9", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Administración de flujos' }]
			},
			component: () => import("@/pages/administrador/flujos.vue"),
			beforeEnter: requireAuth
		},
		{
			name: "detalleindicadorflujo",
			path: "/detalleindicadorflujo/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Administración de flujos', href: '/administrador/flujos' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detalle.vue")
		},
		{
			name: "detalleindicadorGeo",
			path: "/detalleindicadorGeo/:idindicador",
			meta: {
				title: "Detalle de indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Georreferenciación de indicadores con desagregación territorial - PDET', href: '/territorial' }
					, { text: 'Detalle de Indicador' }]
			},
			component: () => import("@/pages/indicador/detalle.vue")
		},
		{
			name: "Home PDET",
			path: "/iniciopdet",
			meta: {
				codigo: "O002-8",
				title: "Programas de Desarrollo con Enfoque Territorial - PDET",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Programas de Desarrollo con Enfoque Territorial - PDET' }]
			},
			component: () => import("@/pages/pdet/inicio.vue")
			, beforeEnter: notrequireAuth

		},
		{
			name: "Territorializacion PDET",
			path: "/territorial",
			meta: {
				title: "Georreferenciación de indicadores con desagregación territorial - PDET",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Georreferenciación de indicadores con desagregación territorial - PDET' }]
			},
			component: () => import("@/pages/pdet/territorial.vue")
			, beforeEnter: notrequireAuth
		},
		{
			name: "Territorializacion PDET from PNS",
			path: "/territorialfromPNS",
			meta: {
				title: "Georreferenciación de indicadores con desagregación territorial - PDET",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Planes Nacionales Sectoriales', href: '/plannacionalvista' }
					, { text: 'Georreferenciación de indicadores con desagregación territorial - PDET' }]
			},
			component: () => import("@/pages/pdet/territorial.vue")
			, beforeEnter: notrequireAuth
		},
		{
			name: "Territorializacion PDET from Clasificacion",
			path: "/territorialfromClasificacionPDET",
			meta: {
				title: "Georreferenciación de indicadores con desagregación territorial - PDET",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Programas de Desarrollo con Enfoque Territorial (PDET).', href: '/iniciopdet' }
					, { text: 'Avance por Clasificación', href: '/avance/clasificacionpdte/1/4' }
					, { text: 'Georreferenciación de indicadores con desagregación territorial - PDET' }]
			},
			component: () => import("@/pages/pdet/territorial.vue")
			, beforeEnter: notrequireAuth
		},
		{
			name: "Iniciativas general",
			path: "/iniciativas",
			meta: {
				title: "Iniciativas - PDET",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Programas de desarrollo con enfoque territorial - PDET', href: '/iniciopdet' }
					, { text: 'Iniciativas PDET' }]
			},
			component: () => import("@/pages/pdet/iniciativa.vue")
			, beforeEnter: notrequireAuth
		},
		{
			name: "Detalle Auditoria",
			path: "/detalleauditoriaav/:idtabla/:idregistro",
			meta: {
				codigo: 'O004-1-7', title: "Detalle auditoria", breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: '	Lista de indicadores', href: '/admindicador' }
					, { text: 'Edición de avances', href: '/administrador/avances/:idindicador?' }
					, { text: 'Detalle auditoría' }]
			},
			component: () => import("@/pages/indicador/detalleauditoria.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/administrador/geometas",
			name: "Geo Metas",
			meta: {
				codigo: "O008-10",
				title: "Consulta Informacion Territorial",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Consulta Informacion Territorial' }]
			},
			component: () => import("@/pages/administrador/geometas.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/recalcularPMI",
			name: "Recalcular Indicadores",
			meta: {
				codigo: "O008-12",
				title: "Recalcular Indiacdores PMI",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Recalcular Indiacdores PMI' }]
			},
			component: () => import("@/pages/administrador/recalculoPMI.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/administrador/tipovalor",
			name: "Tipovalor Indicador",
			meta: {
				codigo: "O008-13",
				title: "Tipovalor Indicador",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Tipovalor Indicador' }]
			},
			component: () => import("@/pages/administrador/tipovalor.vue"),
			beforeEnter: requireAuth
		},
		{
			path: "/sircap",
			name: "Sistema de Rendición de Cuentas Paz - SIRCAP",
			meta: {
				title: "Sistema de Rendición de Cuentas Paz - SIRCAP",
				breadcrumb: [{ text: 'Inicio', href: '/inicio' }
					, { text: 'Sistema de Rendición de Cuentas Paz - SIRCAP' }]
			},
			component: () => import("@/pages/sircap/sircap.vue")
			, beforeEnter: notrequireAuth
		}
	]
});
routes.afterEach(to => {
	let t = DEFAULT_TITLE;
	if (typeof to.meta.title !== undefined) t = DEFAULT_TITLE + " » " + to.meta.title;
	document.title = t;
});
export default routes;
